import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Experience from "./Experience.js"

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.time = this.experience.time
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        // Raycasterインスタンス作成
        this.raycaster = new THREE.Raycaster()

        this.setInstance()
        this.setOrbitControlls()

        window.addEventListener( 'mousemove', (event) =>
        {
            this.pointer = {}
            this.pointer.x = ( event.clientX / this.sizes.width ) * 2 - 1
            this.pointer.y = - ( event.clientY /this.sizes.height ) * 2 + 1
            // 取得したX、Y座標でrayの位置を更新
            this.raycaster.setFromCamera( this.pointer, this.instance )
            // // オブジェクトの取得
            this.intersects = this.raycaster.intersectObjects( this.scene.children )
        })

        // for pc user
        window.addEventListener( 'mousedown', () =>
        {
            this.setRay()
        })

        // for smart phone user
        window.addEventListener( 'touchstart', (event) =>
        {
            this.pointerTap = {}
            this.touchObject = event.changedTouches[0]
            this.pointerTap.x = ( this.touchObject.pageX / this.sizes.width ) * 2 - 1
            this.pointerTap.y = - ( this.touchObject.pageY /this.sizes.height ) * 2 + 1
            // 取得したX、Y座標でrayの位置を更新
            this.raycaster.setFromCamera( this.pointerTap, this.instance )
            // // オブジェクトの取得
            this.intersectsTap = this.raycaster.intersectObjects( this.scene.children )
            this.setRay2()
        })
    }

    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(
            35,
            this.sizes.width / this.sizes.height,
            0.1,
            1000
        )
        this.instance.position.set(4, 3, 7)
        this.scene.add(this.instance)
    }

    setOrbitControlls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        this.controls.rotateSpeed = 0.1
        this.controls.minPolarAngle = Math.PI / 5 // radians
        this.controls.maxPolarAngle = Math.PI / 5 * 2 // radians
        this.controls.minAzimuthAngle  = - Math.PI / 2 // radians
        this.controls.maxAzimuthAngle  = Math.PI / 2 // radians
        this.controls.target = new THREE.Vector3(0, 0, 0)
    }

    setRay()
    {
        if(this.intersects[0])
        {
            if(this.intersects[0].object.name === 'BE' )
            {
                this.url = '#'
                window.open(this.url, "Building Engineering", 'top=50,left=50,width=600,height=600')
            }
            else if(this.intersects[0].object.name === 'A' )
            {
                this.url = '#'
                window.open(this.url, "Arup", 'top=50,left=50,width=600,height=400')
            }
            else if(this.intersects[0].object.name === 'T' )
            {
                this.url = '#'
                window.open(this.url, "Twitter", 'top=50,left=50,width=600,height=600')
            }
        }
    }

    setRay2()
    {
        if(this.intersectsTap[0])
        {
            if(this.intersectsTap[0].object.name === 'BE' )
            {
                this.urlSmart = '#'
                if(!window.open(this.urlSmart))
                {
                    location.href = this.urlSmart
                }
                else
                {
                    window.open(this.urlSmart)
                }
            }
            else if(this.intersectsTap[0].object.name === 'A' )
            {
                this.urlSmart = '#'
                if(!window.open(this.urlSmart))
                {
                    location.href = this.urlSmart
                }
                else
                {
                    window.open(this.urlSmart)
                }
            }
            else if(this.intersectsTap[0].object.name === 'T' )
            {
                this.urlSmart = '#'
                if(!window.open(this.urlSmart))
                {
                    location.href = this.urlSmart
                }
                else
                {
                    window.open(this.urlSmart)
                }
            }
        }
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        this.controls.update()
    }
}